import { Link as RRDLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { externalLinkIconAfter } from '../../layout/snippets';

export const linkBase = css`
  display: inline-flex;
  align-items: center;
  gap: ${size(0.5)};
  text-decoration: none;
  font-weight: var(--font-weight-link);
  color: var(--c-link);
  cursor: pointer;

  ${(props) => props.theme.market.no} {
    text-decoration: underline;
    font-weight: var(--font-weight-regular);

    &:hover {
      color: var(--c-link-hover);
    }
  }

  &:hover {
    text-decoration: underline;
  }
`;

interface LinkProps {
  $hoverGhost?: boolean;
  $currentColor?: boolean;
  $hasContent?: boolean;
  $noExternalIcon?: boolean;
  $wrap?: boolean;
  $size?: 'small';
  $block?: boolean;
}

export const Link = styled.a<LinkProps>`
  ${linkBase}

  ${({ $hoverGhost }) =>
    $hoverGhost &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    `}

  ${({ $block }) =>
    $block &&
    css`
      display: flex;
    `}

  ${({ $currentColor }) =>
    $currentColor &&
    css`
      color: currentColor;
    `}

  ${({ $hasContent }) =>
    $hasContent &&
    css`
      display: inline-flex;
      align-items: center;
    `}

  ${({ $noExternalIcon }) =>
    !$noExternalIcon &&
    css`
      // Add external link icon to external links
      &[target='_blank'] {
        ${externalLinkIconAfter}
      }
    `}

  ${({ $wrap }) =>
    $wrap &&
    css`
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-all;
    `}

    ${({ $size }) =>
      $size === 'small'
        ? css`
          font-size: ${(props) => props.theme.font.size.small};
        `
        : undefined}
`;

export const RouterLink = styled(RRDLink)<LinkProps>`
  ${linkBase}

  ${({ $hoverGhost }) =>
    $hoverGhost &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    `}

  ${({ $currentColor }) =>
    $currentColor &&
    css`
      color: currentColor;
    `}

  ${({ $hasContent }) =>
    $hasContent &&
    css`
      display: inline-flex;
      align-items: center;
    `}

    ${({ $size }) =>
      $size === 'small'
        ? css`
          font-size: ${(props) => props.theme.font.size.small};
        `
        : undefined}
`;

// Apply link styling without being an actual link
export const FakeLink = styled.span`
  ${linkBase};
`;
